import SectionContainer from '@/components/shared/SectionContainer';
import type { ProductDetail } from '@skin-seoul/service';
import { ReviewSection as ReviewSectionComponent } from '@skin-seoul/shared-components';
import { ClientOnly } from '@skin-seoul/utils';
export const REVIEW_SECTION_ID = 'review-section';
type ReviewSectionProps = {
  product: ProductDetail;
};
export default function ReviewSection({
  product
}: ReviewSectionProps) {
  return <SectionContainer containerInnerProps={{
    id: REVIEW_SECTION_ID,
    bg: 'generic.0',
    px: {
      base: '16px',
      tablet: '0px'
    },
    py: {
      base: '20px'
    },
    mx: 0,
    borderTop: '1px solid',
    borderColor: 'neutral.75'
  }} data-sentry-element="SectionContainer" data-sentry-component="ReviewSection" data-sentry-source-file="ReviewSection.tsx">
      <ClientOnly fallback={null} data-sentry-element="ClientOnly" data-sentry-source-file="ReviewSection.tsx">
        <ReviewSectionComponent product={product} data-sentry-element="ReviewSectionComponent" data-sentry-source-file="ReviewSection.tsx" />
      </ClientOnly>
    </SectionContainer>;
}